import { Component, inject } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog'

@Component({
  selector: 'app-layer-shared-confirm-dialog',
  templateUrl: './layer-shared-confirm-dialog.component.html',
  imports: [
    //Material
    MatDialogModule,
    MatButtonModule,
  ],
})
export class LayerSharedConfirmDialogComponent {
  private readonly _dialogRef = inject(MatDialogRef<LayerSharedConfirmDialogComponent>)
  data = inject(MAT_DIALOG_DATA) as { filename: string; isNew: boolean }

  save() {
    this._dialogRef.close(true)
  }

  close() {
    this._dialogRef.close(false)
  }
}
